import React, { Fragment, useEffect, useState } from 'react';
import {
  Card,
  Modal,
  ModalHeader,
  FormGroup,
  Input,
  Form,
  ButtonGroup,
  ModalBody,
  Row,
  Button,
  Label,
  ModalFooter,
  CardBody,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { aPI_Contacts } from '../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import ContactForm from './contactForm';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';

function ContactList({
  propertyId,
  columns,
  data,
  handleContactLoad,
  pageSize,
  taglist = [],
}) {
  const [contact, setContact] = useState();
  const [editContact, setEditContact] = useState(false);
  const toggle = () => setEditContact(!editContact);

  const handleEdit = (body) => {
    AxiosAPI({
      method: 'put',
      url: `${aPI_Contacts}/${contact?.contactId}`,
      data: body,
    }).then((res) => {
      toggle();
      handleContactLoad();
    });
  };

  return (
    <Fragment>
      <Card>
        <CardBody>
          <ReactTable
            data={data}
            columns={columns}
            defaultPageSize={25}
            pageSize={data.length || 1}
            showPagination={false}
            filterable={false}
            minRows={0}
          />
        </CardBody>
      </Card>
      {editContact && contact !== undefined && (
        <ContactForm
          toggle={toggle}
          visible={editContact}
          item={contact}
          propertyId={propertyId}
          taglist={taglist}
          handleSubmit={handleEdit}
        ></ContactForm>
      )}
    </Fragment>
  );
}

export default ContactList;
